import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Who is GROUNDWORK built for?",
    a: "Brand ambassador programs, experiential agencies, sampling teams, and any operation that puts crews on the street. Managers run the dashboard; reps run the app.",
  },
  {
    q: "How do geo-verified check-ins work?",
    a: "Each activation has a geofence. Reps can only check in when their phone confirms they’re physically on-site, so every logged hour is tied to a real location and timestamp.",
  },
  {
    q: "Does it work without signal?",
    a: "Yes. GROUNDWORK caches shifts, tasks, and photo proof locally and syncs automatically the moment connectivity returns — perfect for festivals, basements, and dead zones.",
  },
  {
    q: "Can I export data for payroll and clients?",
    a: "One click. Hours, check-ins, samples scanned, and leads captured export to CSV or straight into your payroll flow, with photo proof attached to each report.",
  },
  {
    q: "Which cities do you support?",
    a: "We’re active in Los Angeles and NYC with remote onboarding available anywhere in the US. Reach out and we’ll spin up your markets.",
  },
  {
    q: "Is there a demo?",
    a: "Absolutely. Drop us a note through the contact form or email info@groundworkmedia.app and we’ll walk your team through a live activation.",
  },
];

const Item = ({ faq, i }) => {
  const [open, setOpen] = useState(i === 0);
  return (
    <Reveal
      delay={i * 0.05}
      className={`border-b-2 border-ink ${open ? "bg-paper" : "bg-transparent"} transition-colors`}
    >
      <button
        data-testid={`faq-trigger-${i}`}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-6 py-7 text-left"
      >
        <span className="font-bebas text-2xl uppercase leading-none tracking-tight sm:text-3xl">{faq.q}</span>
        <motion.span
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.3 }}
          className={`flex h-9 w-9 shrink-0 items-center justify-center border-2 border-ink ${
            open ? "bg-orange text-paper" : "bg-transparent text-ink"
          }`}
        >
          <Plus size={18} />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            data-testid={`faq-content-${i}`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.76, 0, 0.24, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-2xl pb-7 font-mono text-sm leading-relaxed text-muted2">{faq.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </Reveal>
  );
};

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-paper text-ink">
      <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
        <Reveal className="mb-12">
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-orange">/ FAQ</p>
          <h2 className="font-bebas text-5xl uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl">
            Questions from the field.
          </h2>
        </Reveal>
        <div className="border-t-2 border-ink">
          {FAQS.map((faq, i) => (
            <Item key={i} faq={faq} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
